module.exports = __webpack_public_path__ + "img/arrow_circle_left.b1a733cf.svg";